/** Sub-roles that show the insurance / Lamal form. */
export const INSURANCE_FORM_ROLES = ['dentist', 'pediatricdentist'];

/** Sub-roles that show the Medident Neuchâtel form (after LAMAL when both apply). */
export const MEDIDENT_NE_FORM_ROLES = ['medident-ne'];

/** Sub-roles that show the Medident Bern form. */
export const MEDIDENT_BE_FORM_ROLES = ['medident-be'];

/** Sub-roles that show the Medident Genève odontogram form. */
export const MEDIDENT_GE_FORM_ROLES = ['medident'];

/** Sub-roles that show the Medident Valais CC form. */
export const MEDIDENT_VS_CC_FORM_ROLES = ['medident-vs-cc'];

/** Sub-roles that show the Medident Valais SS form. */
export const MEDIDENT_VS_SS_FORM_ROLES = ['medident-vs-ss'];

export const hasInsuranceFormRole = (role) => INSURANCE_FORM_ROLES.includes(role);

export const hasMedidentNeFormRole = (role) => MEDIDENT_NE_FORM_ROLES.includes(role);

export const hasMedidentBeFormRole = (role) => MEDIDENT_BE_FORM_ROLES.includes(role);

export const hasMedidentGeFormRole = (role) => MEDIDENT_GE_FORM_ROLES.includes(role);

export const hasMedidentVsCcFormRole = (role) => MEDIDENT_VS_CC_FORM_ROLES.includes(role);

export const hasMedidentVsSsFormRole = (role) => MEDIDENT_VS_SS_FORM_ROLES.includes(role);

export const shouldHideMissingTeethGridInPdf = (role) => role === 'pediatricdentist';
